function GameIcon({ icon, className = '' }) {
  const iconId = typeof icon === 'string' ? icon : icon?.id;
  const iconSrc = typeof icon === 'string' ? icon : icon?.src;
  const baseIcon = typeof icon === 'string' ? null : icon?.baseId;
  const iconClassName = [
    'game-card-icon',
    baseIcon ? `game-card-icon-${baseIcon}` : '',
    iconId ? `game-card-icon-${iconId}` : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={iconClassName}>
      <img
        className="game-card-icon-art"
        src={iconSrc}
        alt=""
        aria-hidden="true"
      />
    </div>
  );
}

export default GameIcon;
